import { httpsCallable } from "firebase/functions";
import { Asserts } from "yup";
import { functions } from "@/base";
import conviteDiagnosticoSchema from "./components/convite-diagnostico-form/convite-diagnostico-schema";
type ConviteDiagnosticoInputs = Asserts<typeof conviteDiagnosticoSchema>;
export const checkUser = httpsCallable<ConviteDiagnosticoInputs, never>(
  functions,
  "conviteDiagnosticoFunctions-checkUser"
);
